<!-- Breadcrumb only in page mode -->
@if (!drawerMode) {
<app-page-breadcrumb [pageTitle]="pageTitle"></app-page-breadcrumb>
}

<!-- Drawer mode: direct form | Page mode: with card wrapper -->
@if (drawerMode) {
<div class="p-6">
  <ng-container *ngTemplateOutlet="formContent" />
</div>
} @else {
<div class="grid grid-cols-1 gap-6">
  <app-component-card [title]="pageTitle" desc="Complete los datos del lead">
    <ng-container *ngTemplateOutlet="formContent" />
  </app-component-card>
</div>
}

<ng-template #formContent>
  <!-- Loading -->
  @if (loading || loadingCatalogs) {
  <div class="flex justify-center items-center py-12">
    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div>
    <span class="ml-3 text-gray-500 dark:text-gray-400">Cargando datos...</span>
  </div>
  }

  <!-- Error -->
  @if (error) {
  <div class="mb-4 p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20">
    <div class="flex items-center gap-3">
      <svg class="w-5 h-5 text-error-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
      <p class="text-error-600 dark:text-error-400">{{ error }}</p>
    </div>
  </div>
  }

  <!-- Duplicate Error -->
  @if (duplicateError) {
  <div class="mb-4 p-4 bg-warning-50 border border-warning-200 rounded-lg dark:bg-warning-500/10 dark:border-warning-500/20">
    <div class="flex items-center gap-3">
      <svg class="w-5 h-5 text-warning-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
      </svg>
      <p class="text-warning-600 dark:text-warning-400">{{ duplicateError }}</p>
    </div>
  </div>
  }

  <!-- Form -->
  @if (!loading) {
  <form (ngSubmit)="guardar($event)" #leadForm="ngForm" class="space-y-5">

    <!-- Nombre -->
    <div>
      <div class="flex items-center gap-2 mb-1.5">
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">
          Nombre del Lead <span class="text-error-500">*</span>
        </label>
        @if (nameAutoFilled) {
        <span
          class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-success-100 text-success-700 dark:bg-success-500/20 dark:text-success-400 animate-pulse">
          <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
          </svg>
          Auto-completado
        </span>
        }
      </div>
      <input type="text" name="name" [(ngModel)]="name" required maxlength="50" placeholder="Nombre del lead"
        [readonly]="nameAutoFilled && !isEditing"
        (input)="onNameInput()"
        autocomplete="off"
        class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 dark:focus:ring-brand-500/10 transition-all duration-500 disabled:opacity-50 disabled:cursor-not-allowed"
        [class.border-success-400]="nameAutoFilled" [class.bg-success-50]="nameAutoFilled"
        [class.ring-success-500/20]="nameAutoFilled" [class.focus:border-success-400]="nameAutoFilled"
        [class.dark:border-gray-700]="!nameAutoFilled && name.length <= 50"
        [class.dark:opacity-70]="nameAutoFilled && !isEditing"
        [class.dark:cursor-not-allowed]="nameAutoFilled && !isEditing"
        [class.border-error-500]="name.length > 50" [class.focus:border-error-500]="name.length > 50" />
      @if (!name && !isEditing) {
      <p class="mt-1 text-xs text-amber-500 dark:text-amber-400 flex items-center gap-1">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
        </svg>
        Si no escribes un nombre, se autocompletará con el nombre del contacto y la empresa
      </p>
      }
      <div class="mt-1 flex items-center justify-between">
        @if (name.length > 50) {
        <p class="text-xs text-error-500 dark:text-error-400 flex items-center gap-1">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
          </svg>
          El nombre no puede exceder 50 caracteres
        </p>
        } @else {
        <span></span>
        }
        <span class="text-xs" [class.text-error-500]="name.length > 50" [class.text-gray-400]="name.length <= 50">
          {{ name.length }}/50
        </span>
      </div>
    </div>

    <!-- Contacto y Empresa -->
    <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">

      <!-- Contacto typeahead -->
      <div>
        <div class="flex items-center justify-between mb-1.5">
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">
            Contacto <span class="text-error-500">*</span>
          </label>
          <button type="button" (click)="abrirNuevoContacto()"
            title="Crear nuevo contacto"
            class="inline-flex items-center gap-1 px-2 py-1 text-xs font-medium text-brand-600 hover:text-brand-700 hover:bg-brand-50 dark:text-brand-400 dark:hover:text-brand-300 dark:hover:bg-brand-500/10 rounded-md transition-colors">
            <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
            </svg>
            Nuevo
          </button>
        </div>
        <div class="relative">
          <input type="text" [value]="contactSearchTerm" (input)="onContactSearchInput($any($event.target).value)"
            (keydown.enter)="onContactSearchEnter($event)" (blur)="closeContactDropdown()" autocomplete="off"
            placeholder="Buscar contacto... (Enter para ver todos)"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"
            [class.border-gray-300]="!(!idContact && name)" [class.border-error-300]="!idContact && !!name" />
          @if (searchingContacts) {
          <div class="absolute right-3 top-3.5">
            <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500"></div>
          </div>
          }
          @if (idContact) {
          <div class="absolute right-3 top-3.5 text-success-500">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          }
          @if (showContactDropdown && contactSearchResults.length > 0) {
          <div
            class="absolute z-10 mt-1 w-full rounded-lg border border-gray-200 bg-white shadow-lg dark:border-gray-700 dark:bg-gray-900 max-h-48 overflow-y-auto"
            (scroll)="onContactDropdownScroll($event)">
            @for (c of contactSearchResults; track c.id) {
            <button type="button" (mousedown)="selectContact(c)"
              class="w-full px-4 py-2.5 text-left hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors">
              <span class="block text-sm font-medium text-gray-900 dark:text-white">
                {{ c.fullname }} {{ c.lastname || '' }}
              </span>
              <span class="block text-xs text-gray-500 dark:text-gray-400">{{ c.mail }}</span>
            </button>
            }
            @if (loadingMoreContacts) {
            <div class="flex justify-center items-center py-2">
              <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500"></div>
              <span class="ml-2 text-xs text-gray-400 dark:text-gray-500">Cargando más...</span>
            </div>
            }
          </div>
          }
        </div>
      </div>

      <!-- Empresa typeahead -->
      <div>
        <div class="flex items-center justify-between mb-1.5">
          <div class="flex items-center gap-2">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Empresa
            </label>
            @if (companyAutoFilled) {
          <span
            class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-success-100 text-success-700 dark:bg-success-500/20 dark:text-success-400 animate-pulse">
            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
            </svg>
            Auto-completado
          </span>
          }
          </div>
          <button type="button" (click)="abrirNuevaEmpresa()"
            title="Crear nueva empresa"
            class="inline-flex items-center gap-1 px-2 py-1 text-xs font-medium text-brand-600 hover:text-brand-700 hover:bg-brand-50 dark:text-brand-400 dark:hover:text-brand-300 dark:hover:bg-brand-500/10 rounded-md transition-colors">
            <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
            </svg>
            Nuevo
          </button>
        </div>
        <div class="relative">
          <input type="text" [value]="companySearchTerm" (input)="onCompanySearchInput($any($event.target).value)"
            (keydown.enter)="onCompanySearchEnter($event)" (blur)="closeCompanyDropdown()" autocomplete="off"
            placeholder="Buscar empresa... (Enter para ver todas)"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 dark:focus:ring-brand-500/10 transition-all duration-500"
            [class.border-success-400]="companyAutoFilled" [class.bg-success-50]="companyAutoFilled"
            [class.ring-success-500/20]="companyAutoFilled" [class.focus:border-success-400]="companyAutoFilled"
            [class.border-gray-300]="!companyAutoFilled" [class.dark:border-gray-700]="!companyAutoFilled" />
          @if (idCompany) {
          <div class="absolute right-9 top-3.5 text-success-500">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          }
          @if (companySearchTerm) {
          <button type="button" (click)="clearCompany()"
            class="absolute right-3 top-3 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
          }
          @if (searchingCompanies) {
          <div class="absolute right-3 top-3.5">
            <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500"></div>
          </div>
          }
          @if (showCompanyDropdown && companySearchResults.length > 0) {
          <div
            class="absolute z-10 mt-1 w-full rounded-lg border border-gray-200 bg-white shadow-lg dark:border-gray-700 dark:bg-gray-900 max-h-48 overflow-y-auto"
            (scroll)="onCompanyDropdownScroll($event)">
            @for (c of companySearchResults; track c.id) {
            <button type="button" (mousedown)="selectCompany(c)"
              class="w-full px-4 py-2.5 text-left hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors">
              <span class="block text-sm font-medium text-gray-900 dark:text-white">
                {{ c.commercialName }}
              </span>
              @if (c.businessName) {
              <span class="block text-xs text-gray-500 dark:text-gray-400">{{ c.businessName }}</span>
              }
            </button>
            }
            @if (loadingMoreCompanies) {
            <div class="flex justify-center items-center py-2">
              <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500"></div>
              <span class="ml-2 text-xs text-gray-400 dark:text-gray-500">Cargando más...</span>
            </div>
            }
          </div>
          }
        </div>
      </div>

    </div>

    <!-- Ciclo y Estado -->
    <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Ciclo de Lead <span class="text-error-500">*</span>
        </label>
        <select name="idLeadCycle" [(ngModel)]="idLeadCycle" required
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
          [class.border-error-300]="!idLeadCycle">
          @if (!idLeadCycle && leadCycles.length === 0) {
          <option [ngValue]="null" disabled selected>Cargando ciclos...</option>
          }
          @for (cycle of leadCycles; track cycle.id) {
          <option [ngValue]="cycle.id">{{ cycle.name }}</option>
          }
        </select>
      </div>

      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Tipo de Lead <span class="text-error-500">*</span>
        </label>
        <select name="idLeadState" [(ngModel)]="idLeadState" required
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
          [class.border-error-300]="!idLeadState">
          @if (!idLeadState && leadStates.length === 0) {
          <option [ngValue]="null" disabled selected>Cargando tipos...</option>
          }
          @for (state of leadStates; track state.id) {
          <option [ngValue]="state.id">{{ state.name }}</option>
          }
        </select>
      </div>
    </div>

    <!-- Responsable y Creador (Inc 32) -->
    <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Responsable
        </label>
        <app-entity-select
          [value]="userPropietyId"
          (valueChange)="onOwnerChange($event)"
          [displayText]="userPropietyName"
          [searchFn]="userSearch"
          [labelFn]="userLabel"
          [sublabelFn]="userSublabel"
          placeholder="Buscar usuario por nombre o correo…">
        </app-entity-select>
      </div>

      @if (isEditing && userRegisterName) {
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Creado por
        </label>
        <input type="text" [value]="userRegisterName" readonly
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-gray-50 px-4 py-2.5 text-sm text-gray-600 shadow-theme-xs dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300 cursor-not-allowed" />
      </div>
      }
    </div>

    <!-- Retry / Reagendamiento -->
    <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
      <div class="flex items-start gap-3 pt-2">
        <input type="checkbox" name="isRetryScheduled" [(ngModel)]="isRetryScheduled" id="isRetryScheduled"
          class="mt-0.5 h-4 w-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500/10 dark:border-gray-600 dark:bg-gray-800" />
        <div>
          <label for="isRetryScheduled" class="text-sm font-medium text-gray-700 dark:text-gray-300">
            Reagendar seguimiento
          </label>
          <p class="text-xs text-gray-500 dark:text-gray-400">
            Marcar si se debe hacer seguimiento en una fecha específica
          </p>
        </div>
      </div>

      @if (isRetryScheduled) {
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Fecha de Seguimiento
        </label>
        <input type="date" name="retryDate" [(ngModel)]="retryDate"
          [min]="todayDate"
          (click)="$any($event.target).showPicker?.()"
          (focus)="$any($event.target).showPicker?.()"
          class="dark:bg-dark-900 dark:[color-scheme:dark] h-11 w-full cursor-pointer rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
          [class.border-error-500]="retryDateIsPast" />
        @if (retryDateIsPast) {
          <p class="mt-1.5 text-xs text-error-500">La fecha de reintento no puede ser anterior a hoy.</p>
        }
      </div>
      }
    </div>

    <!-- Buttons -->
    <div class="flex items-center justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
      <app-button variant="outline" type="button" (btnClick)="cancelar()">
        Cancelar
      </app-button>
      <app-button variant="primary" type="submit"
        [disabled]="saving || checkingDuplicate">
        {{ saving || checkingDuplicate ? 'Verificando...' : (isEditing ? 'Actualizar' : 'Crear Lead') }}
      </app-button>
    </div>
  </form>
  }
</ng-template>

<!-- Modal: elegir empresa del contacto -->
@if (showCompanyChoiceModal) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
  <div class="bg-white dark:bg-gray-900 rounded-xl shadow-xl w-full max-w-md mx-4">
    <div class="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <h3 class="text-base font-semibold text-gray-900 dark:text-white">
        Empresas asociadas al contacto
      </h3>
      <button type="button" (click)="skipCompanyInModal()"
        class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>
    <div class="px-6 py-4">
      <p class="text-sm text-gray-500 dark:text-gray-400 mb-4">
        El contacto está asociado a múltiples empresas. Selecciona una para asociarla al lead, o cierra para no asociar
        ninguna.
      </p>
      <div class="space-y-2">
        @for (assoc of contactCompaniesForModal; track assoc.id) {
        <button type="button" (click)="selectCompanyInModal(assoc)"
          class="w-full flex items-center gap-3 p-3 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-brand-50 hover:border-brand-300 dark:hover:bg-brand-500/10 dark:hover:border-brand-500/30 transition-colors text-left">
          <div class="flex-shrink-0 w-8 h-8 rounded-full bg-gray-200 dark:bg-gray-700 flex items-center justify-center">
            <svg class="w-4 h-4 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4">
              </path>
            </svg>
          </div>
          <div class="flex-1 min-w-0">
            <p class="text-sm font-medium text-gray-900 dark:text-white truncate">
              {{ assoc.company?.commercialName || 'Empresa #' + assoc.idCompany }}
            </p>
            @if (assoc.isPrimary) {
            <span class="text-xs text-brand-600 dark:text-brand-400 font-medium">Principal</span>
            }
            @if (assoc.position) {
            <p class="text-xs text-gray-500 dark:text-gray-400">{{ assoc.position }}</p>
            }
          </div>
          <svg class="w-4 h-4 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
          </svg>
        </button>
        }
      </div>
    </div>
    <div class="px-6 py-4 border-t border-gray-200 dark:border-gray-700 flex justify-end">
      <button type="button" (click)="skipCompanyInModal()"
        class="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors">
        No asociar empresa
      </button>
    </div>
  </div>
</div>
}

<!-- Close Lead Modal (CLOSE_LEAD trigger) -->
<app-lead-close-modal
  [isOpen]="showCloseLeadModal"
  [lead]="leadForModal"
  [disqualificationReasons]="disqualificationReasons"
  [saving]="savingCloseLead"
  (confirmed)="confirmarCerrarLead($event)"
  (cancelled)="cancelarCerrarLead()">
</app-lead-close-modal>